export default __webpack_public_path__ + "static/media/480_business06-it-mobile.0ecf109c.png";